<template>
    <div class="col-sm-12" style="min-height: 80vh">
        <storm-sewer-drain-search
          :user="user"
          @search="fetchSewerDrains"
        />
        <hr/>
        <storm-sewer-drain-list
          :storm-sewer-drains="results"
          @row-clicked="editSewerDrain"
        />
        <base-modal v-if="editMode" hide-footer hide-header @close="showList">
            <drain-wizard
                :storm-drain="sewerDrain"
                :user="user"
                @close="showList"
                @close-and-update="closeAndUpdate"
            />
        </base-modal>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {downloadHelper} from "../mixins/DownloadMixin";
import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";
import StormSewerDrainSearch from "@/components/stormsewers/StormSewerDrainSearch";
import StormSewerDrainList from "@/components/stormsewers/StormSewerDrainList";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";
import DrainWizard from "@/components/stormsewers/DrainWizard";
import {inject} from "vue";

export default {
    name: 'StormSewerDrains',
    components: {
        DrainWizard,
        BaseModal,
        Navbar,
        StormSewerDrainList,
        StormSewerDrainSearch},
    mixins: [restApi, downloadHelper, stormSewersMixin],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            results: [],
            editMode: false,
            showWizard: false,
            sewerDrain: null,
            loading: false,
            lastSearchedParams: null,
            showFileImporter: false,
            scrollPosition: 0
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    methods: {
        fetchSewerDrains(params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.stormDrainUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        editSewerDrain: function (item) {
            this.editMode = true
            this.sewerDrain = this.jsonToItem(item)
        },
        closeAndUpdate: function () {
            this.fetchSewerDrains(this.lastSearchedParams)
            this.showList()
        },
        exportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.powerStationXlsxUrl, this.getCommonReportParams(this.lastSearchedParams), this.excelDownloadSuccess, this.fileDownloadFail)
        },
        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('power_stations.report_file_name'))
        },
        showList: function () {
            this.editMode = false
            this.showWizard = false
        },
        scrollTop: function () {
            this.scrollPosition = this.$refs.container.scrollTop
            this.$nextTick(function () {
                this.$refs.container.scrollTop = 0
            })
        },
        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },
    }
}
</script>
